var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0773 3.02332C9.35891 3.02332 8.77651 3.60572 8.77651 4.32414V5.62497H7.47568C6.03882 5.62497 4.87402 6.78977 4.87402 8.22663V10.8283H28.2889V8.22663C28.2889 6.78977 27.1241 5.62497 25.6873 5.62497H24.3864V4.32414C24.3864 3.60572 23.804 3.02332 23.0856 3.02332H21.7848C21.0664 3.02332 20.484 3.60572 20.484 4.32414V5.62497H12.679V4.32414C12.679 3.60572 12.0966 3.02332 11.3782 3.02332H10.0773Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2889 13.4299H4.87402V25.1374C4.87402 26.5742 6.03882 27.739 7.47568 27.739H25.6873C27.1241 27.739 28.2889 26.5742 28.2889 25.1374V13.4299ZM8.77651 17.3324C8.77651 16.614 9.35891 16.0316 10.0773 16.0316H12.679C13.3974 16.0316 13.9798 16.614 13.9798 17.3324V18.6333C13.9798 19.3517 13.3974 19.9341 12.679 19.9341H10.0773C9.35891 19.9341 8.77651 19.3517 8.77651 18.6333V17.3324Z",
    fill: "#6C6C6C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.750ee27ccc84dbc69c96f17a35b3d66c.svg";
export { ForwardRef as ReactComponent };